import { BaseAPIRequestFactory, RequiredError } from './baseapi';
import { HttpMethod, HttpInfo } from '../http/http';
import { ObjectSerializer } from '../models/ObjectSerializer';
import { ApiException } from './exception';
import { isCodeInRange } from '../util';
export class TriggerScheduledBackupApiRequestFactory extends BaseAPIRequestFactory {
    async triggerScheduledBackup(projectId, resourceId, scheduleId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("TriggerScheduledBackupApi", "triggerScheduledBackup", "projectId");
        }
        if (resourceId === null || resourceId === undefined) {
            throw new RequiredError("TriggerScheduledBackupApi", "triggerScheduledBackup", "resourceId");
        }
        if (scheduleId === null || scheduleId === undefined) {
            throw new RequiredError("TriggerScheduledBackupApi", "triggerScheduledBackup", "scheduleId");
        }
        const localVarPath = '/projects/{projectId}/inventory/trigger-scheduled-backup'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.PUT, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        if (resourceId !== undefined) {
            requestContext.setQueryParam("resourceId", ObjectSerializer.serialize(resourceId, "string", "uuid"));
        }
        if (scheduleId !== undefined) {
            requestContext.setQueryParam("scheduleId", ObjectSerializer.serialize(scheduleId, "string", "uuid"));
        }
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
}
export class TriggerScheduledBackupApiResponseProcessor {
    async triggerScheduledBackupWithHttpInfo(response) {
        if (isCodeInRange("204", response.httpStatusCode)) {
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, undefined);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
}
